export default "__VITE_ASSET__1e660a84__"